// import realEstateAgentTemplate from './real-estate-agent.pug';
import 'jquery';

export const AgentLike = {
	bindings: {
		formError: '<'
	},
	templateUrl: 'sticky-agent-like.html',
	controller: class RealEstateAgentComponent {
		constructor($mdDialog, CommonConstants, $timeout, $rootScope, loginService, $scope, favouriteService, messagingService, $filter, captchaService) {
			'ngInject';
			this.messagingService = messagingService;
			this.$mdDialog = $mdDialog;
			this.$timeout = $timeout;
			this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			this.numberRegex = /^\d+$/;
			this.model = {};
			this.CommonConstants = CommonConstants;
			this.loginService = loginService;
			this.$rootScope = $rootScope;
			this.$scope = $scope;
			this.favouriteService = favouriteService;
			this.$filter = $filter;
			this.captchaService = captchaService;
		}
		resetCaptchaError() {
			this.agentMessageForm.captcha.$setValidity('invalid', true, this.agentMessageForm)
		}
		submitAgentMessageForm(event) {
			this.messagingService.sendMessageToRealEstateAgent(event.message.model, event.message.captcha).then(
				() => {
					window.ipEventBus.publish('show-info', {
						message: 'successShareNotification',
						dontHide: true
					});
					this.agentMessageFormBackendError = 'success';
				},
				error => {
					if (error.status == 422 || error.status == 412) {
						window.ipEventBus.publish('show-error', {
							message: 'validationError'
						});
					} else if (error.status == 400 && error.data?.error == 'captcha') {
						this.agentMessageForm.captcha.$setValidity('invalid', false, this.agentMessageForm)
						this.agentMessageForm.captcha.$setPristine();
						this.agentMessageForm.captcha.$setUntouched();
						this.captchaText = null;
						this.initCaptcha();
					} else {
						window.ipEventBus.publish('show-error', {
							message: 'technicalError'
						});
					}
					this.agentMessageFormBackendError = 'error';
				}
			);
		}
		$onInit() {
			this.shortPhoneVisible = true;
			window.ipEventBus.subscribe(
				'real-estate-agent-change',
				(channel, { agent, mId }) => {
					this.agent = agent;
					this.phoneNumberShort = this.agent.phone && this.$filter('phoneFilter')(this.agent.phone).substring(0, 10);
					this.mId = mId;
				},
				true
			);
			window.ipEventBus.subscribe(
				'is-logged-in-change',
				(channel, { isLoggedIn }) => {
					this.isLoggedIn = isLoggedIn;
				},
				true
			);
			window.ipEventBus.subscribe(
				'is-liked-change',
				(channel, { isLiked }) => {
					this.$timeout(()=>{
						this.isLiked = isLiked;
					})
				},
				true
			);
		}
		initCaptcha() {
			this.captchaService.getCaptcha().then(
				response => {
					this.captchaId = response.data.captchaId;
					this.captchaImg = response.data.htmlFragment;
				},
				error => {
					window.ipEventBus.publish('show-error', {
						message: 'technicalError'
					});
				}
			);
		}
		openMessageForm() {
			const vm = this;
			this.$mdDialog.show({
				templateUrl: 'general-message-form.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl',
				onComplete() {
					vm.captchaText = null;
					vm.initCaptcha();
				}
			});
		}

		closeMessageForm(type) {
			this.model = {};
			this.$mdDialog.hide();
		}

		send() {
			this.model.agentId = this.agent.id;
			this.model.comissionId = this.mId;
			this.submitAgentMessageForm({
				message: {
					model: this.model,
					captcha: { captchaId: this.captchaId, captchaText: this.captchaText }
				}
			});
		}


		/**
		 *
		 */
		openAgentInfo() {
			this.$mdDialog.show({
				templateUrl: 'real-estate-agent-modal.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			});
		}

		closeAgentInfo() {
			this.$mdDialog.hide();
		}

		showLogin($event) {
			this.loginService.openLoginForm($event);
		}
		showLongPhone() {
			this.shortPhoneVisible = false;
		}
		setFavourite() {
			window.dataLayer.push({
				event: 'pageInit',
				pageType: 'Ingatlan végoldal',
				propertyID: this.mId
			});
			this.favouriteService
				.setFavourite(this.mId)
				.then(() => {
					this.isLiked = !this.isLiked;
					window.ipEventBus.publish('is-liked-change-angular', {isliked: this.isLiked, mId: this.mId});
				})
				.catch(error => {
					console.log(error);
				});
		}
	}
};
